import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { useMemo } from "react";

export function useAdministerResidentInfo() {
  const { resident } = useResidentContext();

  const residentInfo = useMemo(() => {
    return {
      first_name: resident?.first_name,
      last_name: resident?.last_name,
      name: `${resident?.first_name || ""} ${resident?.last_name || ""}`.trim(),
      nickname: resident?.known_as || null,
      roomNumber: resident?.room?.room_number || "None specified",
      bedNumber: resident?.bed?.bed_number || "No bed specified",
      admittedDate: resident?.admission_start_date || "No date specified",
      status: resident?.status,
      profile: resident?.profile_picture?.url || null,
    };
  }, [resident]);

  return {
    residentInfo,
  };
}
